
export enum FormField {
  id = 'id',
  pin = 'pin',
  owner = 'ownerId',
  frequency = 'frequency',
  receiverType = 'receiverType',
}
